import React from "react";
import "./SaleRow.css";
import moment from "moment";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
const SaleRow = (props) => {
  function deleteSale(saleId) {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": props.User.accessToken,
      },
    };

    fetch(`${props.URL}/sales/` + props.sale._id, requestOptions);
  }
  return (
    <div className="tr">
      <div className="td">{moment(props.sale.date).format("DD/MM/YYYY")}</div>
      <div className="td">{props.sale.saleSum.toLocaleString()}$</div>
      <div className="td icons">
        {/* <i className="fas fa-edit icon" /> */}
        <i
          className="fas fa-trash icon"
          onClick={() => {
            toast.warn(
              <div>
                <h5>Are you sure you want to delete FTD?</h5>
                <Button variant="secondary">CANCEL</Button>{" "}
                <Button
                  variant="danger"
                  onClick={() => {
                    deleteSale(props.sale._id);
                  }}
                >
                  CONFIRM
                </Button>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default SaleRow;
